import { ActionIcon } from "@mantine/core"
import { icons } from "../utils"

export function EditIcon({ children, ...props }: Parameters<typeof ActionIcon<"button">>[0]) {
  return (
    <ActionIcon top={18} right={18} size="lg" radius="lg" color="gray" pos="absolute" variant="filled" {...props}>
      {children || <icons.Edit size="1.4rem" />}
    </ActionIcon>
  )
}
